
//GAMES
export const TRICKSTRAT = 'TRICKSTRAT';
export const GEARS4 = 'GEARS4';
export const GEARS5 = 'GEARS5';
export const CSGO = 'CSGO';
export const LAWBREAKERS = 'LAWBREAKERS';
export const RS6 = 'RS6';
export const VALORANT = 'VALORANT';
export const ROGUECOMPANY = 'ROGUECOMPANY';

//export const BANK = 'BANK';
//export const CLUBHOUSE = 'CLUBHOUSE';

export const SPORTS = 'SPORTS';
//DEFAULT
export const WELCOME = 'WELCOME';

//GEARS OF WAR 4
export const AVALANCHE = 'AVALANCHE';
export const BLOODDRIVE = 'BLOODDRIVE';
export const CHECKOUT = 'CHECKOUT';
export const CLOCKTOWER = 'CLOCKTOWER';
export const DAM = 'DAM';
export const DAWN = 'DAWN';
export const DINER = 'DINER';
export const DRYDOCK = 'DRYDOCK';
export const FALLOUT = 'FALLOUT';
export const FORGE = 'FORGE';
export const FOUNDATION = 'FOUNDATION';
export const HARBOR = 'HARBOR';
export const HOTEL = 'HOTEL';
export const IMPACT = 'IMPACT';
export const LIFT = 'LIFT';
export const OLDTOWN = 'OLDTOWN';
export const RECLAIMED = 'RECLAIMED';
export const RELIC = 'RELIC';
export const RUSTLUNG = 'RUSTLUNG';
export const SECURITY = 'SECURITY';
export const THESLAB = 'THESLAB';
export const WARMACHINE = 'WARMACHINE';

//GEARS 5///
export const ASYLUM = 'ASYLUM';
export const BUNKER = 'BUNKER';
export const DISTRICT = 'DISTRICT';
export const EXHIBIT = 'EXHIBIT';
export const ICEBOUND = 'ICEBOUND';
export const TRAININGGROUNDS = 'TRAININGGROUNDS';
export const VASGAR = 'VASGAR';

//CSGO
export const INFERNO = 'INFERNO';
export const TRAIN = 'TRAIN';
export const MIRAGE = 'MIRAGE';
export const NUKE = 'NUKE';
export const COBBLESTONE = 'COBBLESTONE';
export const OVERPASS = 'OVERPASS';
export const CACHE = 'CACHE';

//LawBreakers
export const PROMENADE = 'PROMENADE';
export const REACTOR = 'REACTOR';
export const REDFALLS = 'REDFALLS';
export const STATION = 'STATION';
export const TRENCH = 'TRENCH';
export const VERTIGO = 'VERTIGO';
export const GRANDVIEW = 'GRANDVIEW';
export const MAMMOTH = 'MAMMOTH';

//Sports
export const SOCCER = 'SOCCER';
export const FOOTBALL = 'FOOTBALL';
export const BASKETBALL = 'BASKETBALL';
export const BASEBALL = 'BASEBALL';
export const HOCKEY = 'HOCKEY';

//RS6
export const BANK4 = 'BANK4';
export const BANK3 = 'BANK3';
export const BANK2 = 'BANK2';
export const BANK1 = 'BANK1';
export const CLUBHOUSE4 = 'CLUBHOUSE4';
export const CLUBHOUSE3 = 'CLUBHOUSE3';
export const CLUBHOUSE2 = 'CLUBHOUSE2';
export const CLUBHOUSE1 = 'CLUBHOUSE1';

//VALORANT
export const BIND = 'BIND';
export const HAVEN = 'HAVEN';
export const SPLIT = 'SPLIT';
export const ASCENT = 'ASCENT';

//ROGUECOMPANY
export const CANALS = 'CANALS';
export const FAVELAS = 'FAVELAS';
export const SKYFELL = 'SKYFELL';
export const WINDWARD = 'WINDWARD';
export const ICARUS = 'ICARUS';
export const FACTORY = 'FACTORY';
export const VICE = 'VICE';
export const HIGHCASTLE= 'HIGHCASTLE';



// WEBPACK FOOTER //
// ./src/app/utils/maps/types.js